import { useSuspenseQuery } from '@tanstack/react-query';
import useAuthenticatedFetch from './useAuthenticatedFetch';

// QueryClient doesn't support staleTime per queryKey directly so we define rational defaults here

const staleTimes: Record<string, number> = {
  'account': Infinity,
  'user': Infinity,
  'topics': Infinity,
  'tags': Infinity,
  'custom-fields': Infinity
};

const useSuspenseFetch = (url: string, req = {}) => {
  const handleFetch = useAuthenticatedFetch();
  const staleTime = staleTimes[url] ?? undefined;

  return useSuspenseQuery({
    queryKey: [url],
    queryFn: () => handleFetch(url, req),
    staleTime
  });
};

export default useSuspenseFetch;